import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormCheckbox, useWatch } from '@fs/zion-form'
import { ListItem } from '@fs/zion-ui'
import { ControlDrag } from '@fs/zion-icon'
import Draggable, { dashedBorderCssStyle } from '../../ui/Draggable'
import PersonDisplay from '../PersonDisplay'

export const BaseDraggablePersonDisplay = (props) => {
  const [t] = useTranslation()
  return (
    // UserSelect: none is added to prevent text selection when dragging
    <div style={{ userSelect: 'none' }}>
      <PersonDisplay
        {...props}
        endelement={
          // TouchAction: none is added to prevent scrolling when dragging using touch events
          <div style={{ touchAction: 'none' }}>
            <ListItem.Icon title={t('DraggablePerson.listItem.Icon', 'Drag to reorder')} Icon={ControlDrag} />
          </div>
        }
        // In the new DragNames panel we don't need to know if the person is attached to the tree so we disable the check
        disableCheckForTreeAttachment
      />
    </div>
  )
}

const DraggablePerson = ({ person, record }) => {
  const [t] = useTranslation()

  const [dragInfo, selectedPersonsIds, isMultiSelect] = useWatch({
    name: ['dragInfo', 'selectedPersonsIds', 'isMultiSelect'],
  })

  const isSelected = selectedPersonsIds.some((selectedPersonId) => selectedPersonId === person.id)

  const BaseDraggablePersonDisplayStyle = { overflow: 'hidden', borderRadius: '0.25rem' }
  const selectedAndDraggingCss =
    dragInfo?.isDragging && isSelected
      ? { ...BaseDraggablePersonDisplayStyle, ...dashedBorderCssStyle }
      : BaseDraggablePersonDisplayStyle

  return (
    <Draggable
      key={person?.id}
      id={person?.id}
      style={selectedAndDraggingCss}
      data={{ person, record }}
      testId={`draggable-person-${person?.id}`}
    >
      <BaseDraggablePersonDisplay
        person={person}
        t={t}
        record={record}
        isSelected={isSelected}
        isMultiSelect={isMultiSelect}
        startelement={
          isMultiSelect ? (
            <div style={{ marginInlineStart: '0.5rem' }}>
              <FormCheckbox
                aria-label={t('person-display.checkbox.label', 'Select person')}
                data-testid={`multiselect-checkbox-${person?.id}`}
                name="selectedPersonsIds"
                value={person?.id}
                onClick={(e) => e.stopPropagation()}
                onPointerDown={(e) => e.stopPropagation()}
              />
            </div>
          ) : (
            // Filler to align the person name when it's not multi-select
            <ListItem.Filler width={36} />
          )
        }
        disableDefaultClickHandler
      />
    </Draggable>
  )
}

export default DraggablePerson
